import { ActivatedRoute, Params } from '@angular/router';
import { Breadcrumb, RouterState } from '../entities';

export function getRouteData(route: ActivatedRoute): Partial<RouterState> | null {
    let child = route.firstChild;
    const breadcrumbs: Breadcrumb[] = []; // For future use
    let params: Params = {};

    while (child) {
        if (child.firstChild) {
            params = { ...params, ...child.snapshot.params };
            child = child.firstChild;
        } else {
            return {
                data: child.snapshot.data,
                params: { ...params, ...child.snapshot.params },
                queryParams: child.snapshot.queryParams,
                breadcrumbs
            };
        }
    }

    return null;
}
